import { Search } from "lucide-react";
import { useMemo, useState } from "react";
import { NewsCard } from "../components/NewsCard";
import { useContent } from "../context/ContentContext";
import { headerImageStyle } from "../lib/headerImages";
import { PublicPageSkeleton } from "../components/LoadingSkeleton";

export function NewsPage() {
  const { content, news, loading } = useContent();
  const [query, setQuery] = useState("");
  const filtered = useMemo(
    () => news.filter((post) => `${post.title} ${post.excerpt}`.toLowerCase().includes(query.toLowerCase())),
    [news, query],
  );

  if (loading) return <PublicPageSkeleton variant="cards" />;

  return (
    <>
      <section className="page-hero page-hero--news" style={headerImageStyle(content.headers.news)}><div className="page-width"><span className="eyebrow eyebrow--light"><span /> Neues aus dem Verein</span><h1>Aktuelles</h1><p>Spielberichte, Termine und Geschichten rund um den TTC Rehlingen.</p></div></section>
      <section className="section page-width">
        <div className="news-toolbar">
          <div><strong>{filtered.length}</strong> Beiträge</div>
          <label className="search-field"><Search size={18} /><input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Beiträge durchsuchen" aria-label="Beiträge durchsuchen" /></label>
        </div>
        <div className="news-grid">{filtered.map((post) => <NewsCard key={post.id} post={post} />)}</div>
        {filtered.length === 0 && <div className="empty-state"><h2>Keine Beiträge gefunden</h2><p>Versuche es mit einem anderen Suchbegriff.</p></div>}
      </section>
    </>
  );
}
